// extracted by mini-css-extract-plugin
module.exports = {"globalNotificationWrapper":"GlobalNotification_globalNotificationWrapper__pvwdl","selectionBarNotificationsWrapper":"GlobalNotification_selectionBarNotificationsWrapper__DH0Ta"};